import React, { useEffect } from 'react';
import { useModel, useTexture } from '../../../hooks/use-loaded';
import { useNightTextures } from '../../../hooks/use-night-textures';
import { MixMaterial } from '../materials/MixMaterial';
import { copyTextureProps } from '../../../utils/copy-props';
import { Mesh } from 'three';

export const House = () => {
  const model = useModel('house');

  const day = useTexture('living_room_day_texture');

  useNightTextures(model.scene, [
    'bedroom_top_left_night_texture',
    'bedroom_night_texture',
    'building_frame_night_texture',
    'dining_room_night_texture',
    'doors_night_texture',
    'floor_night_texture',
    'garage_entrance_door_night_texture',
    'garage_hallway_night_texture',
    'kitchen_night_texture',
    'living_room_night_texture',
    'Roof_night_texture',
    'stairs_window_night_texture',
    'walls_night_texture',
  ]);

  useEffect(() => {
    const lr = model.scene.getObjectByName('living_room') as Mesh;

    if (lr!.material instanceof MixMaterial) {
      copyTextureProps(lr.material.map!, day);
      lr.material.map = day;
    }
  }, []);

  return <primitive object={model.scene} scale={[0.0254, 0.0254, 0.0254]} />;
};
